import { createSelector } from 'reselect';

import { composeContextSelectorGroup } from 'utils/redux';
import { getBasketProductIds } from 'store/common/basket/selectors';

import { SharedZoneProductGoodsContext } from '../contexts';
import { SharedZoneInfographic } from '../selectors';

/**
 * Following section contains common selectors for data fields available on all promo blocks
 */
export const getGoodsLength = createSelector(
  SharedZoneInfographic.getGoods,
  (list) => list.length > 0,
);
export const { getIds, getData, getReduced, connect } = composeContextSelectorGroup(
  SharedZoneProductGoodsContext,
  SharedZoneInfographic.getGoods,
  'productId',
);

export const getBadges = getReduced((item) => item.badges || []);
export const getGoodProduct = getReduced((item) => item || {});
export const getBrand = getReduced((item) => item.brand || '');
export const getCategory = getReduced((item) => item.category || '');
export const getCategoryId = getReduced((item) => item.categoryId || '');
export const getImageUrl = getReduced((item) => item.imageUrl || '');
export const getIsPreorder = getReduced((item) => item.isPreorder || null);
export const getOldPrice = getReduced((item) => (item.price || {}).oldValue || null);
export const getPrice = getReduced((item) => (item.price || {}).value || null);
export const getDiscount = getReduced((item) => item.discount || null);
export const getProductId = getReduced((item) => parseInt(item.productId, 10) || '');
export const getRate = getReduced((item) => item.rate || 0);
export const getFeedbackCount = getReduced((item) => item.feedbackCount || null);
export const getRemain = getReduced((item) => item.remain || null);
export const getTitle = getReduced((item) => item.title || '');
export const getUrl = getReduced((item) => item.url || '');
export const getTimer = getReduced((item) => item.timer || null);
export const getLabel = getReduced((item) => item.label || '');
export const getOtzyvyUrl = getReduced((item) => `${item.url}otzyvy` || '');

export const getIsInBasket = createSelector(
  getProductId,
  getBasketProductIds,
  (id, addedItems) => addedItems.indexOf(id) !== -1,
);
